import React, { useEffect, useState } from "react";
import "../components/Student/StuStyles/LiveEvents.css";
import { useNavigate } from "react-router-dom";

import img1 from "../assets/stu-live-program1.png";

import ApiService from "../nhrc_apis/ApiService";

const { EventAPI } = ApiService;

const ITEMS_PER_PAGE = 3;

const Hrliveevents = () => {

  const navigate = useNavigate();

  const [events, setEvents] = useState([]);

  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {

    fetchEvents();

  }, []);

  const fetchEvents = async () => {

    try {

      setLoading(true);

      const response =
        await EventAPI.getHrEvents();

      console.log(
        "HR EVENTS RESPONSE :",
        response
      );

      console.log(
        "HR EVENTS DATA :",
        response?.data
      );

      let eventsList = [];

      /* =====================================
         HANDLE ALL RESPONSE TYPES
      ===================================== */

      if (
        Array.isArray(response?.data)
      ) {

        eventsList =
          response.data;

      } else if (
        Array.isArray(
          response?.data?.data
        )
      ) {

        eventsList =
          response.data.data;

      } else if (
        Array.isArray(
          response?.data?.events
        )
      ) {

        eventsList =
          response.data.events;
      }

      console.log(
        "FINAL EVENTS :",
        eventsList
      );

      setEvents(eventsList);

      setCurrentPage(1); // reset to first page on fresh fetch

    } catch (error) {

      console.log(
        "GET HR EVENTS ERROR :",
        error
      );

      console.log(
        "ERROR RESPONSE :",
        error?.response?.data
      );

    } finally {

      setLoading(false);
    }
  };

  const handleRegister = (
    eventData
  ) => {

    navigate(
      "/hrdashboard/Hreventregister",
      {
        state: {
          event: eventData,
        },
      }
    );
  };

  // ===============================
  // PAGINATION LOGIC
  // ===============================
  const totalPages = Math.ceil(events.length / ITEMS_PER_PAGE);

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;

  const currentEvents = events.slice(
    startIndex,
    startIndex + ITEMS_PER_PAGE
  );

  const handlePrevious = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  return (

    <div className="stu-live-events-wrapper">

      <h2 className="stu-live-events-title">
        Live Event Program
      </h2>

      {loading ? (

        <div className="text-center mt-5">
          <div className="spinner-border text-primary" />
        </div>

      ) : events.length > 0 ? (

        currentEvents.map((e, i) => (

          <div
            key={e.id || i}
            className="stu-live-events-card"
          >

            <div className="stu-live-events-details">

              <p>
                <span>
                  Event Title :
                </span>{" "}
                {e.eventTitle ||
                  e.title ||
                  "N/A"}
              </p>

              <p>
                <span>
                  Organizer Name :
                </span>{" "}
                {e.organizer_name ||
                  e.organizer ||
                  "N/A"}
              </p>

              <p>
                <span>
                  Speaker Name :
                </span>{" "}
                {e.speaker_name ||
                  e.speaker ||
                  "N/A"}
              </p>

              <p>
                <span>
                  Event Mode :
                </span>{" "}
                {e.event_mode ||
                  e.eventmode ||
                  e.mode ||
                  "N/A"}
              </p>

              <p>
                <span>
                  Event Schedule :
                </span>{" "}
                {e.schedule ||
                  e.start_date ||
                  "N/A"}
              </p>

              <p>
                <span>
                  Time :
                </span>{" "}
                {e.time ||
                  e.start_time ||
                  "N/A"}
              </p>

              <p>
                <span>
                  Location :
                </span>{" "}
                {e.location ||
                  e.venue ||
                  "N/A"}
              </p>

              <button
                className="stu-live-events-btn"
                onClick={() =>
                  handleRegister(e)
                }
              >
                REGISTER NOW
              </button>

            </div>

            <img
              src={
                e.image ||
                e.eventImage ||
                e.img ||
                img1
              }
              className="stu-live-events-image"
              alt={
                e.eventTitle ||
                e.title ||
                "event"
              }
            />

          </div>
        ))

      ) : (

        <div className="text-center mt-5">
          <h5>
            No Events Available
          </h5>
        </div>

      )}

      {/* ============================
          PAGINATION CONTROLS
      ============================ */}
      {!loading && events.length > 0 && (
        <div
          className="stu-live-events-pagination"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "16px",
            marginTop: "24px",
          }}
        >
          <button
            className="stu-live-events-btn"
            onClick={handlePrevious}
            disabled={currentPage === 1}
            style={{
              opacity: currentPage === 1 ? 0.5 : 1,
              cursor: currentPage === 1 ? "not-allowed" : "pointer",
            }}
          >
            Previous
          </button>

          <span>
            Page {currentPage} of {totalPages}
          </span>

          <button
            className="stu-live-events-btn"
            onClick={handleNext}
            disabled={currentPage === totalPages}
            style={{
              opacity: currentPage === totalPages ? 0.5 : 1,
              cursor:
                currentPage === totalPages ? "not-allowed" : "pointer",
            }}
          >
            Next
          </button>
        </div>
      )}

    </div>
  );
};

export default Hrliveevents;